import './resources.scss';
import { TweenMax, Circ } from 'gsap';
import InViewportHelper from '../../helpers/in-viewport/in-viewport';
import bodymovin from 'lottie-web';

const ResourcesComponent = {
  el: null,
  resources: null,
  headerInViewport: false,
  sectionBgInViewport: false,
  resourcesInViewport: false,

  init(page) {
    let noAnimations = ['resources'];
    this.resources = document.querySelectorAll('.resource__container');
    this.resources.forEach((resourceCont) => {
      if (noAnimations.indexOf(page) !== -1) { return; }

      this.setupAnimations(resourceCont);
    });

    if (page === 'home') {
      this.homePageInViewAnimation();
      window.addEventListener('scroll', this.homePageInViewAnimation.bind(this));
    }

    if (page === 'resources') {
      let viewAllBtn = this.resources[0].querySelectorAll('.button__view-all')[0];
      if (!viewAllBtn) { return; }
      if (viewAllBtn.getAttribute('load-more') === '') { return; }

      this.resourcePageInViewAnimation();
      window.addEventListener('scroll', this.resourcePageInViewAnimation.bind(this));
      window.addEventListener('featured-resources-hidden', this.resourcePageInViewAnimation.bind(this));
      window.addEventListener('reanimate', this.resourcePageInViewAnimation.bind(this));


      viewAllBtn.addEventListener('click', () => {
        this.resources[0].classList.toggle('resource__items--view-all');
        this.resourcePageInViewAnimation();
      });
    }
  },

  setupAnimations(resourceCont) {
    resourceCont.querySelectorAll('.resource__item').forEach((resource, ind) => {
      let actionType = resource.getAttribute('data-resource-type');
      let iconRef = resource.querySelectorAll('.resource-action__icon')[0];
      let animationName = iconRef.getAttribute('data-animation-name');
      let animationPath = `/dist/animations/${actionType}_icon.json`;

      if (iconRef) {
        let animation = bodymovin.loadAnimation({
          autoplay: false,
          container: iconRef, // Required
          loop: false,
          name: animationName,
          path: animationPath, // Required
          renderer: 'svg'
        });

        let isAnimating = false;

        iconRef.addEventListener('mouseenter', () => {
          if (isAnimating) { return; }
          isAnimating = true;
          bodymovin.play(animationName);
        });

        iconRef.addEventListener('mouseleave', () => {
          isAnimating = false;
          bodymovin.stop(animationName);
        });
      }
    });
  },

  homePageInViewAnimation() {
    this.animateHomeSectionHeader();
    window.setTimeout(this.animateHomeSectionContent.bind(this), 500);
  },

  resourcePageInViewAnimation() {
    this.resourceses = document.querySelectorAll('.resource__container');

    let inViewport = InViewportHelper.checkAny(this.resourceses[0]);

    if (inViewport) {
      this.animateHomeResourceItems();
    }
  },

  initialAnimation(resource) {
    let header = resource.querySelectorAll('.resource__header')[0];
    let headerText = resource.querySelectorAll('.resource__header h2')[0];
    let headerCta = resource.querySelectorAll('.resource__header h3')[0];

    TweenMax.to(header, .5, { paddingBottom: 0, ease: Circ.easeOut });
    TweenMax.to(headerText, .5, { marginTop: '40px', alpha: 1, ease: Circ.easeOut, onComplete: () => {
      headerCta.classList.add('settled');
    }});
  },

  animateHomeSectionHeader() {
    this.resources.forEach((resource) => {
      if (this.headerInViewport) { return; }

      let resourceHeader = resource.querySelectorAll('.resource__header h2')[0];
      let inViewport = InViewportHelper.check(resourceHeader);

      if (inViewport) {
        this.headerInViewport = inViewport;
        this.initialAnimation(resource);
      }
    });
  },

  animateHomeSectionContent() {
    let firstResource = this.resources[0].querySelectorAll('.resource__item')[0];
    let sectionBg = document.querySelectorAll('.resource__container .section-bg')[0];

    if (!this.sectionBgInViewport) {
      let inViewport = InViewportHelper.checkAny(sectionBg);

      if (inViewport) {
        this.sectionBgInViewport = inViewport;
        sectionBg.classList.remove('hidden');

        this.animateHomeResourceItems();
      }
    }
  },

  animateHomeResourceItems() {
    this.resourceseses = document.querySelectorAll('.resource__container');

    let resourceItems = this.resourceseses[0].querySelectorAll('.resource__item');

    resourceItems.forEach((resource, ind) => {
      let baseDelay = .15 * ind;
      TweenMax.to(resource, .5, { alpha: 1, top: 0, delay: baseDelay, ease: Circ.easeOut });

      let resourceImage = resource.querySelectorAll('.resource-item__image')[0];
      TweenMax.to(resourceImage, .5, { alpha: 1, delay: baseDelay });

      let resourceH3 = resource.querySelectorAll('.resource-item__content h3')[0];
      if(resourceH3) {

        TweenMax.to(resourceH3, .5, { left: 0, alpha: 1, delay: (baseDelay + .25), ease: Circ.easeOut })
      }

      let resourceH2 = resource.querySelectorAll('.resource-item__content h2')[0];
      TweenMax.to(resourceH2, .5, { left: 0, alpha: 1, delay: (baseDelay + .35), ease: Circ.easeOut });

      let resourceP = resource.querySelectorAll('.resource-item__content p')[0];
      TweenMax.to(resourceP, .5, { left: 0, alpha: 1, delay: (baseDelay + .45), ease: Circ.easeOut });

      let resourceA = resource.querySelectorAll('.resource-item__more-link')[0];
      TweenMax.to(resourceA, .5, { left: 0, alpha: 1, delay: (baseDelay + .55), ease: Circ.easeOut });

      let resourceAction = resource.querySelectorAll('.resource-item__action')[1];
      if (!resourceAction) {
        resourceAction = resource.querySelectorAll('.resource-item__action')[0];
      }
      TweenMax.to(resourceAction, .5, { top: '100%', alpha: 1, delay: (baseDelay + .65), ease: Circ.easeOut });
    });
  }
};

export default ResourcesComponent;
